export default __webpack_public_path__ + "static/media/AdditionExerciseButton.04f78ccd.png";